/**
 * The ORGANIZAÇÃO nav labels, which the topbar trail also reads: the
 * catalogue page keeps its own `title` -- this catalogue holds only what the
 * sidebar itself says, its second level (`overview`, `profile`) included.
 * Split out of `./pt-BR.ts` and `./en.ts` rather than edited in place there,
 * so this task and the one rewriting that file's transactional-email copy
 * touch no line in common.
 */
import { defineCatalogue } from '../../../i18n';

const pt = {
  home: 'Campanhas',
  catalogue: 'Perfis de coleta',
  overview: 'Visão geral',
  profile: 'Perfil',
};

const en = {
  home: 'Campaigns',
  catalogue: 'Collection profiles',
  overview: 'Overview',
  profile: 'Profile',
};

const navCatalogue = defineCatalogue(pt, en);

export const nt = navCatalogue.t;
